/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from './auth.service';
import {Roles, RolesData} from '../../../domain/authorization/roles';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

    constructor(private authService: AuthService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        const dataAuth = route.data['auth'];
        const auth = dataAuth instanceof AuthInfo ? dataAuth : AuthInfo.DEFAULT;
        return auth.allowUnauthorizedUsers || this.authService.user$
                .map(user => user && (auth.roles.length === 0 || user.hasAnyRole(auth.roles.map(k => Roles[k]))))
                .do(value => { if (!value) this.authService.redirectUnauthorizedUser(state.url); });
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>
        | Promise<boolean>
        | boolean {
        return this.canActivate(childRoute, state);
    }
}

class AuthInfoData {
    readonly allowUnauthorizedUsers: boolean = false;
    readonly roles: Array<keyof RolesData> = [];
}

export class AuthInfo extends AuthInfoData {
    static DEFAULT = new AuthInfo(new AuthInfoData());

    constructor(data: Partial<AuthInfoData>) {
        super();
        Object.assign(this, data);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/security/authorization/auth.guard.ts